import datepicker from 'js-datepicker';

import Form from '../_form';
import Cookies from '../../utils/class/cookies';

import debounce from '../../utils/debounce';
import formatDate from '../../utils/date';

export default class ProjectCreateForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const { projectID } = this.setCookies();

        this.projectID = projectID || this.setDraft();

        this.setSave();

        this.setDatepicker();
        this.setAccess();
        this.setInvitation();

        this.setNavigation();
    }

    setCookies () {
        this.cookies = new Cookies();

        return {
            projectID: this.cookies.getProperty('pp_creation', 'project/id')
        }
    }

    async setDraft () {
        try {
            await fetch('/wp-json/projects/v1/draft', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.projectID = data.id;

                    this.cookies.set('pp_creation', { project: { id: data.id, step: 1 } }, { expires: 1800 });

                    this.NotificationManager.sendNotification('success', 'New project draft created!', data.message);
                } else {
                    this.NotificationManager.sendNotification('error', 'Draft creation error...', data.message);
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'Draft creation error...', 'Please, try to reload the page');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'Draft creation error...', 'Please, try to reload the page');
        }
    }

    setSave () {
        this.fields.forEach((field) => {
            const input = field.querySelector('input, textarea');

            const save = async (value, name) => {
                try {
                    await fetch('/wp-json/projects/v1/save', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ id: this.projectID, name, value })
                    })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data && !data.error) {
                            this.NotificationManager.sendNotification('success', 'Data saved!', data.message);
                        } else {
                            this.NotificationManager.sendNotification('error', 'Data save error...', data.message);
                        }
                    })
                    .catch(() => {
                        this.NotificationManager.sendNotification('error', 'Data save error...', 'Please, try to reload the page');
                    });
                } catch (error) {
                    this.NotificationManager.sendNotification('error', 'Data save error...', 'Please, try to reload the page');
                }
            };

            input.addEventListener('change', () => {
                if (field.classList.contains('site-field--error') || input.name === 'search') return;

                save(input.value, input.name);
            });
        });
    }

    setDatepicker () {
        const field = this.form.querySelector('#expiration-date');
        if (!field) return;

        const today = new Date();
        const tomorrow = new Date();

        tomorrow.setDate(today.getDate() + 1);

        this.datepicker = datepicker('#expiration-date', {
            minDate: tomorrow,
            onSelect: () => field.dispatchEvent(new Event('change')),
            formatter: (input, date) => {
                const parsed = date.toLocaleString('en-GB').split(',')[0];
                const formatted = parsed.split('/').reverse().join('-');

                const value = formatDate(formatted, 'MMMM d, yyyy');

                input.value = value;
            },
            onShow: () => field.classList.add('triggered'),
            onHide: () => field.classList.remove('triggered')
        });

        if (field.value) {
            const [day, month, year] = field.value.split('.');
            const date = new Date(`${year}-${month}-${day}`);

            if (date) this.datepicker.setDate(date);
        }
    }

    setAccess () {
        const privateField = this.form.querySelector('#access-private');
        if (!privateField) return;

        const publicField = this.form.querySelector('#access-public');
        if (!publicField) return;

        const invitationField = this.form.querySelector('#invitation-field');
        if (!invitationField) return;

        privateField.addEventListener('change', (event) => {
            event.stopPropagation();
            
            if (privateField.checked) {
                invitationField.classList.remove('hidden');
            }
        });

        publicField.addEventListener('change', (event) => {
            event.stopPropagation();
            
            if (publicField.checked) {
                invitationField.classList.add('hidden');

                const search = this.form.querySelector('input[name="search"]');

                const list = this.form.querySelector('#invitation-search-results');
                const attached = this.form.querySelector('#attached-users');

                search.value = '';
                list.innerHTML = '';
                list.classList.add('hidden');

                attached.innerHTML = '';

                this.attached = [];
            }
        });

        if (privateField.checked) privateField.dispatchEvent(new Event('change'));
    }

    setInvitation () {
        const handleSearch = () => {
            const gthis = this;
    
            const search = this.form.querySelector('input[name="search"]');
            const list = this.form.querySelector('#invitation-search-results');
    
            const field = this.form.querySelector('input[name="search"]').parentNode;
            const attached = this.form.querySelector('#attached-users');
    
            this.formParts.list = list;
            this.formParts.field = field;
    
            const clear = () => {
                list.innerHTML = '';
                list.classList.add('hidden');
            }
    
            const handler = debounce(function () {
                const { value } = search;
    
                const reName = /^[a-zA-Z\s]+$/;
                const reEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
                const valid = reName.test(value.trim().toLowerCase()) || reEmail.test(value.trim().toLowerCase());
    
                if (value.length >= 3 && valid) {
                    (async () => {
                        try {
                            await fetch('/wp-json/user/v1/search', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ value })
                            })
                            .then((response) => response.json())
                            .then((data) => {
                                if (data.data && data.data.length && !data.error) {
                                    data.data.forEach((user) => {
                                        const li = document.createElement('li');
    
                                        li.setAttribute('tabindex', '0');
                                        li.setAttribute('data-user', `user-${user.id}`);
    
                                        li.innerHTML = `
                                            <div class="site-project--invitation-form-list-profile">
                                                ${user.profile_picture 
                                                    ? `<img src="${user.profile_picture}" alt="${user.display_name}" />` 
                                                    : `<div class="site-project--invitation-form-list-profile-placeholder">${user.display_name.charAt(0).toUpperCase()}</div>`
                                                }
                                            </div>
                                            <div class="site-project--invitation-form-list-data">
                                                <h4 class="h5 site-title site-project--invitation-form-list-name">
                                                    ${user.display_name}
                                                </h4>
                                                <div class="site-project--invitation-form-list-email">
                                                    ${user.user_email}
                                                </div>
                                            </div>
                                        `;
    
                                        li.addEventListener('click', (event) => {
                                            event.stopPropagation();
    
                                            const instance = {
                                                id: user.id,
                                                output: user.display_name,
                                                internal: true
                                            }
    
                                            const isDuplicate = gthis.attached.find((item) => item.id === user.id);
    
                                            if (!isDuplicate) {
                                                gthis.attached.push(instance);
    
                                                const ili = document.createElement('li');
    
                                                ili.innerHTML = `
                                                    <span>${user.display_name}</span>
                                                    <button class="site-button icon">
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M15.1831 3.93306L3.93306 15.1831C3.81585 15.3003 3.75 15.4592 3.75 15.625C3.75 15.7908 3.81585 15.9497 3.93306 16.0669C4.05027 16.1842 4.20924 16.25 4.375 16.25C4.54076 16.25 4.69973 16.1842 4.81694 16.0669L16.0669 4.81694C16.1842 4.69973 16.25 4.54076 16.25 4.375C16.25 4.20924 16.1842 4.05027 16.0669 3.93306C15.9497 3.81585 15.7908 3.75 15.625 3.75C15.4592 3.75 15.3003 3.81585 15.1831 3.93306Z" fill="#D5D5D5"></path>
                                                            <path d="M4.81694 3.93306C4.69973 3.81585 4.54076 3.75 4.375 3.75C4.20924 3.75 4.05027 3.81585 3.93306 3.93306C3.81585 4.05027 3.75 4.20924 3.75 4.375C3.75 4.54076 3.81585 4.69973 3.93306 4.81694L15.1831 16.0669C15.3003 16.1842 15.4592 16.25 15.625 16.25C15.7908 16.25 15.9497 16.1842 16.0669 16.0669C16.1842 15.9497 16.25 15.7908 16.25 15.625C16.25 15.4592 16.1842 15.3003 16.0669 15.1831L4.81694 3.93306Z" fill="#D5D5D5"></path>
                                                        </svg>
                                                    </button>
                                                `;
    
                                                attached.append(ili);
    
                                                ili.querySelector('button').addEventListener('click', (e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
    
                                                    ili.remove();
    
                                                    gthis.attached.splice(gthis.attached.indexOf(instance), 1);
                                                });
                                            }
    
                                            search.value = '';
                                            list.innerHTML = '';
                                            list.classList.add('hidden');
                                        });
    
                                        list.append(li);
                                    });
    
                                    list.classList.remove('hidden');
                                } else {
                                    if (reEmail.test(value.trim().toLowerCase())) {
                                        const li = document.createElement('li');
    
                                        li.setAttribute('tabindex', '0');
    
                                        li.innerHTML = `
                                            <div class="site-project--invitation-form-list-profile">
                                                <div class="site-project--invitation-form-list-profile-placeholder">@</div>
                                            </div>
                                            <div class="site-project--invitation-form-list-data">
                                                <h4 class="h5 site-title site-project--invitation-form-list-name">
                                                    ${value.trim().toLowerCase()}
                                                </h4>
                                                <div class="site-project--invitation-form-list-email">
                                                    Invitation by email
                                                </div>
                                            </div>
                                        `;
    
                                        list.append(li);
    
                                        li.addEventListener('click', (event) => {
                                            event.stopPropagation();
    
                                            const instance = {
                                                id: null,
                                                output: value.trim().toLowerCase(),
                                                internal: false
                                            }
    
                                            const isDuplicate = gthis.attached.find((item) => item.internal === false && item.output === instance.output);
    
                                            if (!isDuplicate) {
                                                gthis.attached.push(instance);
    
                                                const ili = document.createElement('li');
    
                                                ili.classList.add('external');
    
                                                ili.innerHTML = `
                                                    <span>${instance.output}</span>
                                                    <button class="site-button icon">
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M15.1831 3.93306L3.93306 15.1831C3.81585 15.3003 3.75 15.4592 3.75 15.625C3.75 15.7908 3.81585 15.9497 3.93306 16.0669C4.05027 16.1842 4.20924 16.25 4.375 16.25C4.54076 16.25 4.69973 16.1842 4.81694 16.0669L16.0669 4.81694C16.1842 4.69973 16.25 4.54076 16.25 4.375C16.25 4.20924 16.1842 4.05027 16.0669 3.93306C15.9497 3.81585 15.7908 3.75 15.625 3.75C15.4592 3.75 15.3003 3.81585 15.1831 3.93306Z" fill="#5C5C5C"></path>
                                                            <path d="M4.81694 3.93306C4.69973 3.81585 4.54076 3.75 4.375 3.75C4.20924 3.75 4.05027 3.81585 3.93306 3.93306C3.81585 4.05027 3.75 4.20924 3.75 4.375C3.75 4.54076 3.81585 4.69973 3.93306 4.81694L15.1831 16.0669C15.3003 16.1842 15.4592 16.25 15.625 16.25C15.7908 16.25 15.9497 16.1842 16.0669 16.0669C16.1842 15.9497 16.25 15.7908 16.25 15.625C16.25 15.4592 16.1842 15.3003 16.0669 15.1831L4.81694 3.93306Z" fill="#5C5C5C"></path>
                                                        </svg>
                                                    </button>
                                                `;
    
                                                attached.append(ili);
    
                                                ili.querySelector('button').addEventListener('click', (e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
    
                                                    ili.remove();
    
                                                    gthis.attached.splice(gthis.attached.indexOf(instance), 1);
                                                });
                                            }
    
                                            search.value = '';
                                            list.innerHTML = '';
                                            list.classList.add('hidden');
                                        });
    
                                        list.classList.remove('hidden');
                                    }
                                }
                            })
                            .catch(() => {
                                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
                            });
                        } catch (error) {
                            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
                        }
                    })();
                } else {
                    list.innerHTML = '';
                    list.classList.add('hidden');
                }
            }, 300);
    
            search.addEventListener('input', clear);
            search.addEventListener('input', handler);
        }

        const handleList = () => {
            const list = this.form.querySelector('#invitation-search-results');
    
            const observer = new MutationObserver(() => {
                if (list.children.length > 0) {
                    list.classList.remove('hidden');
                } else {
                    list.classList.add('hidden');
                }
            });
        
            observer.observe(list, { childList: true });
        
            if (list.children.length > 0) {
                list.classList.remove('hidden');
            } else {
                list.classList.add('hidden');
            }
        }

        this.attached = [];

        const attachedEl = this.form.querySelector('#attached-users');

        this.attached = new Proxy(this.attached, {
            set: (target, property, value) => {
                const result = Reflect.set(target, property, value);

                if (property === 'length') {
                    if (target.length > 0) {
                        this.submit.removeAttribute('disabled');

                        attachedEl.classList.remove('hidden');
                    } else {
                        this.submit.setAttribute('disabled', '');

                        attachedEl.classList.add('hidden');
                    }
                }

                return result;
            }
        });

        this.formParts = {};

        handleSearch();
        handleList();
    }

    setNavigation () {
        const validateStep = (step) => {
            const fields = step.querySelectorAll('.site-field');
            if (!fields || !fields.length) return;

            const required = [...fields].filter((field) => field.dataset.required === 'true');
            if (!required || !required.length) return;

            const next = step.querySelector('.primary[data-step]');

            const validation = this.validateFields(required, false);

            if (next) {
                next.removeAttribute('disabled');

                /* eslint-disable-next-line no-unused-expressions */
                validation ? next.removeAttribute('disabled') : next.setAttribute('disabled', '');
            }
        };

        const validateForm = () => {
            const fields = this.form.querySelectorAll('.site-field');
            if (!fields || !fields.length) return;

            const required = [...fields].filter((field) => field.dataset.required === 'true');
            if (!required || !required.length) return;

            const validation = this.validateFields(required, false);

            if (this.submit) {
                /* eslint-disable-next-line no-unused-expressions */
                validation ? this.submit.removeAttribute('disabled') : this.submit.setAttribute('disabled', '');
            }
        }

        const steps = [...this.form.querySelectorAll('.site-creation--step')];
        const navs = [...this.form.querySelectorAll('.site-creation--navigation ul li[data-step]')];

        const activateStep = (key = 1) => {
            const target = steps.find((s) => s.dataset.formStep === `${key}`);
            if (!target) return;
    
            steps.forEach((s) => s.classList.remove('active'));
            target.classList.add('active');
    
            window.scrollTo({ top: 0, behavior: 'smooth' });
    
            navs.forEach((nav) => nav.classList.remove('active'));
            navs.filter((nav) => nav.dataset.step <= key).forEach((nav) => nav.classList.add('active'));

            this.cookies.setProperty('pp_creation', 'project/step', key);

            validateStep(target);

            validateForm();
        };
    
        activateStep(this.cookies.getProperty('pp_creation', 'project/step'));
        validateForm();

        steps.forEach((step) => {
            const buttons = step.querySelectorAll('[data-step]');
            if (!buttons || !buttons.length) return;
    
            buttons.forEach((button) => {
                const key = button.dataset.step;
    
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    activateStep(key);
                });
            });

            const fields = step.querySelectorAll('.site-field');
            if (!fields || !fields.length) return;

            const required = [...fields].filter((field) => field.dataset.required === 'true');
            if (!required || !required.length) return;

            required.forEach((field) => {
                const input = field.querySelector('input, textarea');

                ['change', 'input'].forEach((type) => {
                    input.addEventListener(type, (event) => {
                        event.stopPropagation();
    
                        validateStep(step);
                        validateForm();
                    });
                });
            });
        });
    }

    async inviteParticipants(attached, postID, url) {
        /* eslint-disable */
        for (const [index, item] of attached.entries()) {
            await new Promise((resolve) => setTimeout(resolve, index * 1000));
    
            const userID = item.id;
            const { internal, output } = item;
    
            try {
                await fetch('/wp-json/projects/v1/invite', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ internal, id: userID, email: output, 'post_id': postID })
                });
            } catch (error) {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
            }
        }
        /* eslint-enable */
    
        this.NotificationManager.sendNotification('success', 'Participants invited! Redirecting...', 'The project sent for review. You will receive a notification when it\'s published.');
        
        setTimeout(() => window.location.href = url, 2000);
    
        if (this.submit) this.submit.classList.remove('preload');
    }


    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const id = this.projectID;

        if (!id) {
            this.NotificationManager.sendNotification('error', 'Project draft unavailable...', 'Please, try again later');

            return;
        }

        const attached = JSON.parse(JSON.stringify(this.attached)) || [];

        const title = formData.get('title');
        const description = formData.get('description');
        const cover = formData.get('cover-image-url') || '';
        const amount = formData.get('target-amount');
        const date = formData.get('expiration-date');
        const access = formData.get('access');
        const location = formData.get('location');

        const bankFullname = formData.get('bank-fullname');
        const bankEmail = formData.get('bank-email');
        const bankName = formData.get('bank-name');
        const bankSortCode = formData.get('bank-sort-code');
        const bankAccountNumber = formData.get('bank-account-number');
        const bankIBAN = formData.get('bank-iban');
        const bankSWIFT = formData.get('bank-swift');
        const bankNotes = formData.get('bank-notes');

        try {
            await fetch('/wp-json/projects/v1/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id, title, description, amount, date, access, location, cover,
                    bankFullname, bankEmail, bankName, bankSortCode, bankAccountNumber, bankIBAN, bankSWIFT, bankNotes
                })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.cookies.delete('pp_creation');

                    if (!attached.length) {
                        this.NotificationManager.sendNotification('success', 'Project created! Redirecting...', data.message);

                        setTimeout(() => window.location.href = data.url, 3000);
    
                        if (this.submit) this.submit.classList.remove('preload');
                    } else {
                        this.NotificationManager.sendNotification('success', 'Inviting participants...', data.message);

                        this.inviteParticipants(attached, id, data.url);
                    }
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}